import { render, staticRenderFns } from "./PreviewJobMainArticle.vue?vue&type=template&id=a2d1aa94&scoped=true"
import script from "./PreviewJobMainArticle.vue?vue&type=script&lang=js"
export * from "./PreviewJobMainArticle.vue?vue&type=script&lang=js"
import style0 from "./PreviewJobMainArticle.vue?vue&type=style&index=0&id=a2d1aa94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d1aa94",
  null
  
)

export default component.exports